import React from 'react'
import { BubblesData as BData_1} from './bubbles-t1.data'
import { BubblesData as BData_2} from './bubbles-t2.data'
import { BubblesData as BData_3} from './bubbles-t3.data'
import { BubblesData as BData_4} from './bubbles-t4.data'
import { BubblesData as BData_5} from './bubbles-t5.data'
import { BubblesData as BData_6} from './bubbles-t6.data'
import { BubblesData as BData_7} from './bubbles-t7.data'
import { BubblesData as BData_8} from './bubbles-t8.data'
import { BubblesData as BData_9} from './bubbles-t9.data'
import { BubblesData as BData_10} from './bubbles-t10.data'

import Recorridos from './../../../utils/import.recor360'

import mobileAndTabletCheck from './../../../utils/mobileCheck'

import close from './../../../UI/icons/Galerias/Close.svg'
import recor360 from './../../../UI/icons/Tooltip/Recor360.svg'
import renders from './../../../UI/icons/Tooltip/Renders.svg'

let imageSize = ['100%', '100%'];
let barOffset = 0;
if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
    barOffset = 5;
    imageSize = ['calc(84% * 1.77778)', '84%'];
}

interface Bubbles{
    BData: any,
    bubbles: any,
    btnref: any,
    array: any
}

interface Props{
    angle: number,
    show: boolean,
    tower: any,
    category: any,
    apto: any
    zoom: any,
    leftOffset: any,
    topOffset: any,
    handleGeneralGallery: any,
    handle360Click: any,
    loadingCanvas: boolean
}

interface State{
    aptos: any,
    apto: any,
    showTooltip: boolean,
    clientX: any,
    clientY: any,
    currentApto: any,
    showGallery: boolean,
    show360: boolean,
    isMouseDown: boolean,
    isMouseMoving: boolean
}

class Bubbles extends React.Component<Props, State>{
    constructor(props: Props){
        super(props)
        this.state = {
            aptos: [],
            apto: [],
            showTooltip: false,
            clientX: "",
            clientY: "",
            currentApto: "",
            showGallery: false,
            show360: false,
            isMouseDown: false,
            isMouseMoving: false
        }
    }

    componentDidMount(){
        this.BData = {
            'Torre 2': BData_2(),
            'Torre 1': BData_1(),
            'Torre 3': BData_3(),
            'Torre 4': BData_4(),
            'Torre 5': BData_5(),
            'Torre 6': BData_6(),
            'Torre 7': BData_7(),
            'Torre 8': BData_8(),
            'Torre 9': BData_9(),
            'Torre 10': BData_10(),
        }

        this.bubbles = this.BData['Torre 2']
        this.bubbles = this.BData['Torre 1']
        this.bubbles = this.BData['Torre 3']
        this.bubbles = this.BData['Torre 4']
        this.bubbles = this.BData['Torre 5']
        this.bubbles = this.BData['Torre 6']
        this.bubbles = this.BData['Torre 7']
        this.bubbles = this.BData['Torre 8']
        this.bubbles = this.BData['Torre 9']
        this.bubbles = this.BData['Torre 10']

        this.btnref = React.createRef()

        document.addEventListener("mousedown", () => {
            this.setState({
                isMouseDown: true
            })
        })
        document.addEventListener("mouseup", () => {
            this.setState({
                isMouseDown: false,
                isMouseMoving: false
            })
        })
        document.addEventListener("mouseleave", () => {
            this.setState({
                isMouseDown: false,
                isMouseMoving: false
            })
        })
        document.addEventListener("mousemove", () => {
            if(this.state.isMouseDown){
                this.setState({
                    isMouseMoving: true
                })
            }
        })
    }

    componentDidUpdate(prevProps: any){
        if(mobileAndTabletCheck() && window.innerHeight > window.innerWidth){
            barOffset = 0;
            imageSize = ['calc(84% * 1.77778)', '84%'];
        }
        else {
            imageSize = ['100%', '100%'];
            barOffset = 0;
        }

        this.updateBDataRef();

        if(prevProps.show !== this.props.show){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.tower !== this.props.tower || prevProps.category !== this.props.category || prevProps.apto !== this.props.apto){
            this.createBubbles();
            this.forceUpdate();
        }

        if(prevProps.angle !== this.props.angle){
            this.createBubbles();
            this.forceUpdate();
        }
    }

    createBubbles = () => 
    {
        let angle = this.props.angle
        this.array = []

        if(!this.updateBDataRef()){           
            return;
        }
        
        if(this.bubbles[angle] === undefined){
            return this.props.angle
        }        
        
        for (let i = 0; i < this.bubbles[angle].length; i++) {

            if((this.props.apto !== "" && (this.props.apto) !== "Apto Tipo " + this.bubbles[angle][i].tipo)){
                continue;
            }           

            this.array.push(
                <polygon
                key={i} 
                points = {
                    "" + this.bubbles[angle][i].verts[0][0] + "," + this.bubbles[angle][i].verts[0][1] + " " + 
                    this.bubbles[angle][i].verts[1][0] + "," + this.bubbles[angle][i].verts[1][1] + " " + 
                    this.bubbles[angle][i].verts[3][0] + "," + this.bubbles[angle][i].verts[3][1] + " " + 
                    this.bubbles[angle][i].verts[2][0] + "," + this.bubbles[angle][i].verts[2][1]
                }
                style = {{
                    fill: (this.bubbles[angle][i].tipo === "Valle") ? "rgba(68,157,110,.2)" : 
                    (this.bubbles[angle][i].tipo === "PH Valle") ? "rgba(2,90,102,.2)" : 
                    (this.bubbles[angle][i].tipo === "Rio") ? "rgba(97,79,68,.2)" : 
                    (this.bubbles[angle][i].tipo === "PH Rio") ? "rgba(0,120,139,.2)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Delux") ? "rgba(105,112,92,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Natural") ? "rgba(166,206,148,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Classic") ? "rgba(128,132,173,.7)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Panoramic") ? "rgba(248,205,107,.7)" :
                    "rgba(193,153,67,.5)",

                    stroke: (this.bubbles[angle][i].tipo === "Valle") ? "rgba(68,157,110,.82)" : 
                    (this.bubbles[angle][i].tipo === "PH Valle") ? "rgba(2,90,102,.82)" : 
                    (this.bubbles[angle][i].tipo === "Rio") ? "rgba(97,79,68,.82)": 
                    (this.bubbles[angle][i].tipo === "PH Rio") ? "rgba(0,120,139,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Delux") ? "rgba(105,112,92,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Natural") ? "rgba(166,206,148,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Classic") ? "rgba(128,132,173,.82)" :
                    (this.bubbles[angle][i].tipo === "Apto Tipo Panoramic") ? "rgba(248,205,107,.82)" :
                    "rgba(193,153,67,.8)",
                    strokeWidth: 2,
                    visibility: 'visible',
                    cursor: 'pointer'
                }}

                onMouseDown = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                onTouchStart = {this.showToolTip.bind(this, this.bubbles[angle][i])}
                >
                

                </polygon>
            )
            
        }
        
        this.forceUpdate()
    }

    showToolTip = (apto: any, e: any) => {

        this.setState({
            clientX: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientX : e.clientX, 
            clientY: e.type.indexOf('touch') === 0 ? e.changedTouches[0].clientY : e.clientY,
            apto: apto,
            showTooltip: true,
            currentApto: apto.num
        }, () => {
            this.setState({
                show360: Object.keys(Recorridos).includes("Apto Tipo "+this.state.apto.tipo),
                showGallery: apto.a && apto.a.Galeria.length > 0
            })
            
        })    
    }

    hideTooltip = () => {
        this.setState({
            showTooltip: false,
            apto: null
        })
    }

    updateBDataRef = () => {
        if(this.props.tower !== ''){
            this.bubbles = this.BData[this.props.tower];
        } else {
            return false;
        }
        return true
    }

    updateBubbles = (aptos: any, bubbles: any) => {
        aptos.forEach((apto: any) => {
            bubbles.forEach((frame: any) => {
                for(let bubble of frame) {
                    let count = 0;
                    if("Apto Tipo " + bubble.tipo === apto.tipo){
                        //bubble.disp = apto.disp
                        bubble.t = apto.t
                        bubble.a = apto.a                        
                        count++;
                        if(count >= 2){
                            break;
                        }                        
                    }
                };
            })
        });
    }

    updateAvailability = (aptos: any, torre: any) => {
        this.setState({
            aptos: aptos
        }, () => {
            this.updateBubbles(this.state.aptos, this.bubbles);
            this.createBubbles();
        })

        if(this.BData[torre]){
            this.updateBubbles(aptos, this.BData[torre])
        }
    }

    render(){
        return(
            <div 
                className={this.props.show && !this.props.loadingCanvas ? "bubbles fade-in":"bubbles fade-out"}
                style = {{
                    pointerEvents: 'none',
                    width: '100%',
                    height: '100%',
                    transform: 'scale('+this.props.zoom+') translate(calc(' + this.props.leftOffset + '%), calc('+ barOffset +'% + '+ this.props.topOffset + '%))'
                }}
            >
                    <svg 
                    width={'100%'}
                    height={'100%'}
                    preserveAspectRatio="xMidYMid slice"
                    viewBox="0 0 1920 1080"
                    style={{
                        overflow: 'hidden',
                        pointerEvents: 'none',
                        position: 'absolute'
                    }}>
                        <g style={{
                            pointerEvents: this.state.isMouseDown && this.state.isMouseMoving ? "none":"visibleFill"
                        }}>
                            {this.array}
                        </g>
                        
                    </svg>

                    <div className={this.state.showTooltip ? "tooltip fade-in":"tooltip fade-out"} 
                        onMouseLeave = { this.hideTooltip.bind(this) }
                        style={{
                            left: this.state.clientX  + 'px',
                            top: this.state.clientY + 'px',
                        }}
                    >
                        <div className='close-tooltip'
                            onClick={() => {this.hideTooltip()}}
                            onTouchStart={() => {this.hideTooltip()}}
                        >
                            <img src={close}/>
                        </div>
                        <div className='tooltip-tittle'>{this.state.apto ? "Apto Tipo "+ this.state.apto.tipo:null}</div>
                        
                        {
                            this.state.show360 || this.state.showGallery ? 
                            <React.Fragment>
                                <hr className='tooltip-hr'/>
                                <div className='multimedia-container'>
                                    {
                                        this.state.showGallery ? 
                                        <div
                                            onClick={() => {this.props.handleGeneralGallery(this.state.apto.a)}}
                                        >
                                            <img src={renders}/>
                                        </div>: null
                                    }
                                    {
                                        this.state.show360 ? 
                                        <div
                                        onClick={() => {this.props.handle360Click("Apto Tipo " + this.state.apto.tipo)}}
                                        >
                                            <img src={recor360}/>
                                        </div>: null
                                    }
                                </div>
                            </React.Fragment>:null
                        }
                    </div>
            </div>
        )
    }
}

export default Bubbles